export default __webpack_public_path__ + "static/media/logo-black-transparent.530260d5.png";